<template>
    <div class="footer-wrap">
        <div class="footer">
            <div class="title">比赛单位</div>
            <div class="logo-list">
                <div class="logo">
                    <div class="img"><img src="../assets/images/makex.png"></div>
                    <div class="name">主办方：MakeX机器人挑战赛组委会</div>
                </div>
                <div class="logo">
                    <div class="img"><img src="../assets/images/makex.png"></div>
                    <div class="name">主办单位：深圳市葫芦创客科技有限公司</div>
                </div>
                <div class="logo">
                    <div class="img"><img src="../assets/images/makeblock.png"></div>
                    <div class="name">协办单位：深圳市创客工场科技有限公司</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style lang="scss" scoped>
    .footer-wrap {
        background: #010519;
        padding: 75px 0 125px;
    }
    .footer {
        width: 1220px;
        margin: 0 auto;
        .title {
            font-size: 18px;
            color: #fff;
            line-height: 36px;
            border-bottom: 1px solid rgba(151, 151, 151, .4);
            margin-bottom: 45px;
        }
        .logo-list {
            display: flex;
            justify-content: space-between;
            .logo {
                text-align: center;
                color: #fff;
                .img {
                    height: 40px;
                }
                img {
                    margin-bottom: 18px;
                }
            }
        }
    }
</style>
